import { render } from "./GlobalHeader.vue?vue&type=template&id=bfc7ed28"
import script from "./GlobalHeader.vue?vue&type=script&lang=js"
export * from "./GlobalHeader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=bfc7ed28&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__